import { combineReducers } from "redux";
import { cartReducer } from "./cartReducer";
import { userReducer } from "./userReducer";

export const rootReducer = combineReducers({
    cartReducer,
    userReducer
})
export type RootState = ReturnType<typeof rootReducer>